import { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import ProtectedImage from "@/components/ProtectedImage";
import api from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (u && u.startsWith("http") ? u : `${BACKEND}${u}`);

const Frame = ({ url }) => {
  const [hidden, setHidden] = useState(false);
  if (hidden) return null;
  return (
    <div className="mx-3 bg-white p-2 pb-2 border-[3px] border-ink rounded-2xl shadow-brut">
      <ProtectedImage>
        <img src={url} alt="caricature example" draggable={false}
          onError={() => setHidden(true)}
          onLoad={(e) => { if (e.target.naturalWidth <= 4) setHidden(true); }}
          className="w-72 sm:w-80 h-72 sm:h-96 object-contain bg-cream-solid rounded-lg border-2 border-ink" />
      </ProtectedImage>
    </div>
  );
};

export default function HeroGallery({ fallback = [] }) {
  const [imgs, setImgs] = useState([]);

  useEffect(() => {
    api.get("/gallery")
      .then((r) => {
        const urls = (r.data || []).map((g) => abs(g.url)).filter(Boolean);
        setImgs(urls.length ? urls : fallback);
      })
      .catch(() => setImgs(fallback));
  }, [fallback]);

  if (!imgs.length) return null;

  return (
    <div className="relative h-[440px] sm:h-[520px] flex items-center overflow-hidden" data-testid="hero-scroller">
      <Marquee direction="right" speed={45} gradient={false} pauseOnHover autoFill>
        {imgs.map((u, i) => <Frame key={i} url={u} />)}
      </Marquee>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-cream to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-cream to-transparent z-10" />
      <span className="pointer-events-none absolute -bottom-1 left-3 font-accent text-2xl text-bubble z-20">so you!</span>
    </div>
  );
}
